import { render, staticRenderFns } from "./AuthRequestModal.vue?vue&type=template&id=4549e621&scoped=true&"
import script from "./AuthRequestModal.vue?vue&type=script&lang=ts&"
export * from "./AuthRequestModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4549e621",
  null
  
)

export default component.exports